import React from 'react';
import { useIsMobile } from '../../../../../hooks/isMobile';
import { PluginProps } from '../Plugin';

const getJustifyContent = (alignment: string): any => {
  switch (alignment) {
    case 'right':
    case 'align-right':
      return 'flex-end';
    case 'left':
    case 'align-left':
      return 'flex-start';

    case 'center':
    default:
      return 'center';
  }
};

const YoutubeEmbed = (props: PluginProps) => {
  const { content } = props;
  const contentData = content.data;
  const isMobile = useIsMobile();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: getJustifyContent(contentData.align),
        minWidth: isMobile ? '100%' : '400px',
      }}
    >
      <div className="youtube_embed" style={{ width: contentData.width }}>
        <div className={`yt_container`}>
          <div
            style={{
              position: 'relative',
              aspectRatio: '16 / 9',
              height: 'auto',
              overflow: 'hidden',
              display: 'block',
              maxWidth: '100%',
            }}
          >
            <iframe
              className="youtube_iframe"
              src={`https://www.youtube-nocookie.com/embed/${contentData.video_id}?start=${contentData.start_sec}&enablejsapi=1&rel=0`}
              frameBorder="0"
              width="560"
              height="315"
              style={{
                minWidth: isMobile ? '100%' : '450px',
                position: 'absolute',
                width: '100%',
                height: '100%',
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title={contentData.title}
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YoutubeEmbed;
